export const GET_ORDERS_WAYS_INFO = 'orders-ways-modal/GET_ORDERS_WAYS_INFO';
export const getOrdersWaysInfoAction = id => ({
	type: GET_ORDERS_WAYS_INFO,
	id,
});

export const SET_ORDERS_WAYS_INFO = 'orders-ways-modal/SET_ORDERS_WAYS_INFO';
export const setOrdersWaysInfoAction = payload => ({
	type: SET_ORDERS_WAYS_INFO,
	payload,
});

export const SET_IS_ORDERS_WAYS_INFO_LOADING = 'orders-ways-modal/SET_IS_ORDERS_WAYS_INFO_LOADING';
export const setIsOrdersWaysInfoLoadingAction = payload => ({
	type: SET_IS_ORDERS_WAYS_INFO_LOADING,
	payload,
});

export const DELETE_ORDERS_WAYS = 'orders-ways-modal/DELETE_ORDERS_WAYS';
export const deleteOrdersWaysAction = payload => ({
	type: DELETE_ORDERS_WAYS,
	payload,
});

export const SET_IS_ORDERS_WAYS_DELETING = 'orders-ways-modal/SET_IS_ORDERS_WAYS_DELETING';
export const setIsOrdersWaysDeletingAction = payload => ({
	type: SET_IS_ORDERS_WAYS_DELETING,
	payload,
});

export const CREATE_ORDERS_WAYS = 'orders-ways-modal/CREATE_ORDERS_WAYS';
export const createOrdersWaysAction = payload => ({
	type: CREATE_ORDERS_WAYS,
	payload,
});

export const UPDATE_ORDERS_WAYS = 'orders-ways-modal/UPDATE_ORDERS_WAYS';
export const updateOrdersWaysAction = payload => ({
	type: UPDATE_ORDERS_WAYS,
	payload,
});

export const SET_IS_ORDERS_WAYS_SAVING = 'orders-ways-modal/SET_IS_ORDERS_WAYS_SAVING';
export const setIsOrdersWaysSavingAction = payload => ({
	type: SET_IS_ORDERS_WAYS_SAVING,
	payload,
});

export const GET_GROUP_ID_LIST = 'orders-ways-modal/GET_GROUP_ID_LIST';
export const getGroupIdListAction = payload => ({
	type: GET_GROUP_ID_LIST,
	payload,
});

export const SET_GROUP_ID_LIST = 'orders-ways-modal/SET_GROUP_ID_LIST';
export const setGroupIdListAction = payload => ({
	type: SET_GROUP_ID_LIST,
	payload,
});

export const SET_IS_CARRIERS_LIST_LOADING = 'orders-ways-modal/SET_IS_CARRIERS_LIST_LOADING';
export const setIsCarriersListLoadingAction = payload => ({
	type: SET_IS_CARRIERS_LIST_LOADING,
	payload,
});

export const RESET_STATE = 'orders-ways-modal/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});
